import { isNull } from 'lodash/fp';

const AnswerCorrectness = props => {
  const { correctAnswer } = props;
  if (isNull(correctAnswer)) {
    return t('grades.ungraded');
  }

  return correctAnswer ? t('grades.correct') : t('grades.incorrect');
};

export default AnswerCorrectness;
